import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/f565a7fbaff3aba5022d427758761498.jpg"
          alt="Korea Vietnam Trade Route"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-navy/90 via-navy/70 to-navy/50" />
        <div className="absolute inset-0 bg-gradient-to-t from-navy/60 via-transparent to-navy/20" />
      </div>

      {/* Decorative Data Lines */}
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <svg className="w-full h-full" viewBox="0 0 1920 1080" preserveAspectRatio="xMidYMid slice">
          <line x1="0" y1="400" x2="1920" y2="600" stroke="#C0C5CE" strokeWidth="1" strokeDasharray="8,12" />
          <line x1="0" y1="600" x2="1920" y2="300" stroke="#C0C5CE" strokeWidth="0.5" strokeDasharray="4,20" />
          <circle cx="480" cy="460" r="6" fill="#C0C5CE" opacity="0.8" />
          <circle cx="1440" cy="520" r="6" fill="#C0C5CE" opacity="0.8" />
          <circle cx="960" cy="490" r="3" fill="#C0C5CE" opacity="0.6" />
        </svg>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full pt-24 lg:pt-0">
        <div className="max-w-3xl">
          {/* Eyebrow */}
          <div className="flex items-center gap-3 mb-6 lg:mb-8 animate-fade-in">
            <span className="text-silver text-xs font-sans tracking-[0.25em] uppercase font-medium">
              {t('hero.eyebrow')}
            </span>
          </div>

          {/* Main Headline */}
          <h1 className="font-serif text-white mb-2 leading-tight animate-fade-in-up">
            <span className="block text-[38px] sm:text-[56px] lg:text-[72px] font-bold tracking-tight leading-none">
              {t('hero.headline1')}
            </span>
            <span className="block text-[30px] sm:text-[42px] lg:text-[56px] font-light text-silver mt-2">
              {t('hero.headline2')}{' '}
              <span className="text-white font-semibold transition-all duration-500">
                {t('hero.headline3')}
              </span>
            </span>
          </h1>

          <p className="text-silver/80 text-base lg:text-lg font-sans font-light leading-relaxed max-w-xl mt-4 mb-8 lg:mt-6 lg:mb-10 animate-fade-in">
            {t('hero.desc')}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4 animate-fade-in">
            <Link
              to="/services"
              className="px-8 py-4 bg-white text-navy text-sm font-sans font-semibold tracking-wide hover:bg-silver-light transition-all duration-300 rounded cursor-pointer whitespace-nowrap w-full sm:w-auto text-center"
            >
              {t('hero.cta1')}
            </Link>
            <Link
              to="/contact"
              className="px-8 py-4 border border-silver text-silver text-sm font-sans font-medium tracking-wide hover:bg-white/10 transition-all duration-300 rounded cursor-pointer whitespace-nowrap w-full sm:w-auto text-center"
            >
              {t('hero.cta2')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}